import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import NewsRepositoriesFactory from '../Repositories/factory.js'

class GetNewsByIdsNewsUseCase extends UseCase {
  #httpNewsRepository

  constructor({httpNewsRepository}) {
    super()
    this.#httpNewsRepository = httpNewsRepository
  }

  static create({config}) {
    return new GetNewsByIdsNewsUseCase({
      httpNewsRepository: NewsRepositoriesFactory.hTTPNewsRepository({config})
    })
  }

  @tracer({metric: 'GetNewsByIdsNewsUseCase#execute'})
  @AsyncInlineError()
  async execute({ids}) {
    if (!ids?.length) return {items: []}

    const articles = await this.#httpNewsRepository.getByIds({ids})
    return {items: articles.map(article => article.toJSON())}
  }
}

export const factory = GetNewsByIdsNewsUseCase.create
